// Formatação e leitura de números como no protótipo: vírgula decimal, "—" para vazio.

export const fmt = (n: number | null | undefined, d = 2) =>
  n == null || !Number.isFinite(n) ? "—" : Number(n).toLocaleString("pt-BR", { maximumFractionDigits: d });

/** Lê "12,5" ou "12.5"; devolve null para o que não for número. */
export const num = (v: unknown): number | null => {
  const n = Number.parseFloat(String(v ?? "").replace(",", "."));
  return Number.isFinite(n) ? n : null;
};

/** "2–4", ou um valor só quando os extremos coincidem. */
export const faixa = (lo: number, hi?: number | null, d = 2) =>
  hi == null || Math.abs(hi - lo) < 1e-9 ? fmt(lo, d) : `${fmt(lo, d)}–${fmt(hi, d)}`;

/** "2026-11-01" → "01/11/2026". */
export const dataBR = (iso?: string | null) => (iso ? iso.split("-").reverse().join("/") : "");
